import React from 'react';

import MainMenu from 'client/common/components/main-menu';
import { IMainMenuProps } from 'client/common/components/main-menu/mainMenu';

import './index.css';

export default ({ siteSearchUrl, menu }: Pick<IMainMenuProps, 'siteSearchUrl' | 'menu'>) =>
    <MainMenu hasSearch scrollableHead menu={menu} siteSearchUrl={siteSearchUrl} />;
